@if(isBrowser){
<main>
  <!-- header START -->
  <div class="container-fluid">
    <app-header (shareUserDetail)="setUserDetails($event)"></app-header>
  </div>
  <!-- header END -->
  @if (userDetail) {
  <div>
    <!-- ALL SECTION -->
    <section class="body-left-insidepages">
      <div class="body-pad">
        <h1 class="wow animate__fadeInUp" data-wow-delay="100ms" style="margin-bottom: 80px;">Hubspot.com Integration with
          KudosHub</h1>
        <!-- INTEGRATE IMAGES START -->
        <div class="first-section">
          <!-- <div class="brand-div"> -->
          <div class="integrate-div wow animate__fadeInUp">
            <!-- make it routerLink to activate section -->
            <img src="theme/images/kudosHub-logo.svg" data-wow-delay="200ms" alt="Kudoshub">
          </div>
          <!-- <h2 id="KudosHub-a" class="wow animate__fadeInUp" data-wow-delay="200ms">KudosHub</h2>
          </div> -->
          <!-- <div class="brand-div"> -->
          <div class="plus-icon wow animate__fadeInUp">
            <img src="theme/images/transfer.webp" data-wow-delay="500ms" alt="integation">
          </div>
          <!-- <h2 id="with-a" class="wow animate__fadeInUp" data-wow-delay="200ms">with</h2>
          </div> -->
          <!-- <div class="brand-div"> -->
          <div class="integrate-div wow animate__fadeInUp">
            <!-- make it routerLink to activate section -->
            <img src="theme/images/integration/HUBSPOT.svg" data-wow-delay="500ms" alt="Hubspot">
          </div>
          <!-- <h2 id="other-a" class="wow animate__fadeInUp" data-wow-delay="200ms">Hubspot</h2>
          </div> -->
          <!-- BACKGROUND IMAGE START -->
          <div class="bgUp"></div>
          <div class="bgUp2"></div>
          <!-- BACKGROUND IMAGE END -->
        </div>
        <!-- INTEGRATE IMAGES END -->
        <!-- INTEGRATE SEACTION START -->
        <!-- <div id="section-2">
          <div class="integrate  wow animate__fadeInUp" data-wow-delay="500ms">


          </div>
        </div> -->
        <!-- INTEGRATE SECTION END -->
        <!-- INTEGRATION PARAGRAPH START -->

        <div id="section-3">
          <p class="wow animate__fadeInUp" data-wow-delay="300ms">Powered by AI Email Scoring. Secure, fast, and ready
            to scale.</p>
          <button class="get-started-btn2 wow animate__fadeInUp" data-wow-delay="400ms" routerLink="/register">Get 3,000
            Free
            Credits</button>
          <p class="wow animate__fadeInUp" data-wow-delay="500ms"
            style="font-weight:500;padding:0;text-align: center !important; animation-delay: 1500ms; margin-top: 5px !important; margin-bottom: 10px; font-size: 16px !important;">
            Simple setup. Seamless connection.</p>
        </div>
        <div class="middle-content">
          <h2 class="bdy-left-mainhead wow animate__fadeInUp" style="text-transform: none;">
            What’s Included in the KudosHub Hubspot.com Integration
          </h2>
          <figure class="wave wow animate__fadeInUp">
            <img src="theme/images/wave.gif" alt="KudosHub Technologies" width="43" height="9" loading="lazy" />
          </figure>
          <div class="disclaimer-points wow animate__fadeInUp">
            <p class="wow animate__fadeInUp">
              Get advanced real-time email validation inside Hubspot.com. Validate, score, and sync contacts with 99%
              accuracy through a secure API connection.
            </p>
            <!-- <p class="wow animate__fadeInUp"></p> -->
            <ul>
              <li class="wow animate__fadeInUp">
                <h3>Real-Time Email Validation</h3> - KudosHub runs 16+ intelligent checks to identify invalid,
                disposable, risky, and catch-all emails directly inside Hubspot.com.
              </li>
              <li class="wow animate__fadeInUp">
                <h3>AI-Powered Email Scoring</h3> - Each email receives a quality score that helps teams filter
                low-value contacts and prioritize stronger leads.
              </li>
              <li class="wow animate__fadeInUp">
                <h3>99% Verified Accuracy</h3> - Achieve trusted results with proven 99% accuracy that reduces bounces
                and prevent spam traps to protect sender reputation.
              </li>
              <li class="wow animate__fadeInUp">
                <h3>Automated Data Sync</h3> - Validation results and AI scores sync automatically inside Hubspot.com to
                keep all contact records updated and accurate.
              </li>
              <li class="wow animate__fadeInUp">
                <h3>Secure API Connection</h3> - All API requests use encrypted HTTPS connections to ensure safe data
                transfer between your Hubspot workspace and KudosHub.
              </li>
              <li class="wow animate__fadeInUp">
                <h3>Dedicated Integration Support</h3> - Get responsive help from the KudosHub team for setup,
                troubleshooting & optimization to ensure a smooth Hubspot.com integration.
              </li>
            </ul>
          </div>
          <h2 class="bdy-left-mainhead wow animate__fadeInUp" style="text-transform: none;">
            Why Validating Emails Inside Hubspot.com Matters
          </h2>

          <figure class="wave wow animate__fadeInUp">
            <img src="theme/images/wave.gif" alt="KudosHub Technologies" width="43" height="9" loading="lazy" />
          </figure>

          <div class="disclaimer-points wow animate__fadeInUp">
            <p class="wow animate__fadeInUp">
              Data quality decides campaign success. Validating emails inside Hubspot.com keeps your workflows clean, your
              deliverability strong, and your sender reputation protected.
            </p>

            <ul>
              <li class="wow animate__fadeInUp">
                <h3>Built for Real-Time Precision</h3> - KudosHub doesn’t just verify syntax. It runs 16+ AI-powered
                checks — detecting spam traps, catch-alls, role accounts, and temporary emails before they reach Hubspot.
              </li>

              <li class="wow animate__fadeInUp">
                <h3>Protect Deliverability and Domain Health</h3> - Invalid or risky contacts create bounce spikes that
                damage sender reputation. KudosHub filters them instantly to maintain consistent inbox placement.
              </li>

              <li class="wow animate__fadeInUp">
                <h3>Stop Wasting Resources on Bad Leads</h3> - Invalid contacts waste email credits, CRM space, and team
                time. KudosHub ensures only verified, high-quality leads reach Hubspot automations.
              </li>

              <li class="wow animate__fadeInUp">
                <h3>Enhance Targeting with AI Email Scoring</h3> - Not all valid emails perform equally. KudosHub ranks
                each address by engagement potential to help you prioritize responsive leads.
              </li>

              <li class="wow animate__fadeInUp">
                <h3>Achieve Long-Term List Hygiene</h3> - Automated validation keeps Hubspot records accurate over time.
                KudosHub updates results in real time to prevent list decay.
              </li>
            </ul>
          </div>
          <h2 class="bdy-left-mainhead wow animate__fadeInUp" style="text-transform: none;">
            How to Set Up the KudosHub Hubspot.com Integration
          </h2>
          <figure class="wave wow animate__fadeInUp">
            <img src="theme/images/wave.gif" alt="KudosHub Technologies" width="43" height="9" loading="lazy" />
          </figure>
          <p style="text-align: center;" class="wow animate__fadeInUp">Follow these steps to connect KudosHub with Hubspot.com using our validation API.
            Configure your action, map
            fields, and automate real-time email verification.</p>
          <div class="step-section">
            <div class="step-element">
              <h3 class="step-head wow animate__fadeInUp">Create Your KudosHub API Key</h3>
              <p class="wow animate__fadeInUp">Generate your API key inside the KudosHub dashboard. Use it in all authenticated requests to the
                validation endpoint for secure access.</p>
              <div class="step-element">
                <h3 class="step-head wow animate__fadeInUp">Configure the Hubspot.com HTTP Action</h3>
                <p class="wow animate__fadeInUp">Create an HTTP request action in Hubspot.com. Set the method to POST and point the URL to the KudosHub
                  validation endpoint.
                </p>
              </div>
              <div class="step-container wow animate__fadeInUp">
                <strong>
                  <Section></Section>Step 1
                </strong>
                <div>
                  <h4>Open the Actions menu : </h4>
                  <p>Go to the Actions panel inside your Hubspot table and choose the Enrichment
                    tab.
                  </p>
                </div>
              </div>
              <div class="step-container wow animate__fadeInUp">
                <strong>Step 2</strong>
                <div>
                  <h4>Select the HTTP API action : </h4>
                  <p>Search for the HTTP API option and open the configure tab.
                  </p>
                </div>
              </div>
              <div class="img-container">
                <img src="theme/images/integration/Hubspot/configure_tab.webp" alt="Hubspot-Kudoshub Integration panel">
              </div>
              <div class="step-container wow animate__fadeInUp">
                <strong>Step 3</strong>
                <div>
                  <h4>Add the KudosHub validation endpoint : </h4>
                  <p>Enter the following URL and set the method to POST:</p>
                  <br>
                                    <a href="#" (click)="copyToClipboard($event)">https://api.kudoshub.com/v1/validate<span class="tooltiptext">{{copyButtonText}}</span></a>

                </div>
              </div>
              <!-- <div class="container">
                <app-code-editor [codeSnippets]="validateSingle" [showLineNumbers]="false" [showCopyButton]="true"
                  [heading]="singleEmailHead" [showHeader]="false">
                </app-code-editor>
              </div> -->
              <div class="step-container wow animate__fadeInUp">
                <strong>Step 4</strong>
                <div>
                  <h4>Add your required query parameters : </h4>
                  <p>In the Query Parameters section, fill in:</p>
                  <p><strong>email : </strong>select the email column to validate</p>
                  <p><strong>api-key : </strong>paste your KudosHub API key</p>
                                    <a href="#" (click)="copyToClipboard($event)">https://api.kudoshub.com/v1/validate<span class="tooltiptext">{{copyButtonText}}</span></a>

                </div>
              </div>
              <div class="img-container">
                <img src="theme/images/integration/Hubspot/method_section.webp" alt="Hubspot-Kudoshub Integration panel">
              </div>
              <div class="step-container wow animate__fadeInUp">
                <strong>Step 5</strong>
                <div>
                  <h4>Enable AI scoring for deeper lead insights (optional) : </h4>
                  <p>Add the scoring parameter to receive an
                    AI-generated quality score for each email. This helps you identify stronger leads, improve
                    targeting,
                    and prioritize contacts that are more likely to convert. To include AI email scoring, add:-
                  </p>
                  <p><strong>score : </strong>true
                  <p class="wow animate__fadeInUp">
                    <a href="https://api.kudoshub.com/v1/validate">https://api.kudoshub.com/v1/validate</a>
                </div>
              </div>
              <div class="img-container">
                <img src="theme/images/integration/Hubspot/scoring_true.webp" alt="Hubspot-Kudoshub Integration panel">
              </div>
              <div class="step-container wow animate__fadeInUp">
                <strong>Step 6</strong>
                <div>
                  <h4>Credit usage details : </h4>
                  <p>Validation uses 1 KudosHub credit.
                    Validation plus scoring uses 2 credits, one for each operation.
                  </p>
                </div>
              </div>
              <div class="step-container wow animate__fadeInUp">
                <strong>Step 7</strong>
                <div>
                  <h4>Save your configuration : </h4>
                  <p>Click Save to store your settings.
                  </p>
                </div>
              </div>
              <div class="step-container wow animate__fadeInUp">
                <strong>Step 8</strong>
                <div>
                  <h4>Run the validation request : </h4>
                  <p>Press Run to send your first request and receive validation results.
                  </p>
                </div>
              </div>
              <div class="step-container wow animate__fadeInUp">
                <strong>Step 9</strong>
                <div>
                  <h4>Expand and map the returned data : </h4>
                  <p>Click the returned value to see status, score, and details.
                    Replace existing columns or create new ones to store the results. </p>
                </div>
              </div>
            </div>
          </div>
          <!-- TABLE START -->

          <h2 class="bdy-left-mainhead wow animate__fadeInUp">FAQ's</h2>
          <figure class="wave wow animate__fadeInUp">
            <img src="theme/images/wave.gif" alt="KudosHub Technologies" width="43" height="9" />
          </figure>
          <div id="faq" class="faq-body">
            <div class="faq-header">
              <div class="faq-list">
                <div class="wow animate__fadeInUp" data-wow-delay="100ms">
                  <details>
                    <summary>What are KudosHub integrations and how to connect with other tools?</summary>
                    <div class="faq-content">
                      <p>KudosHub integrations let you connect your email validation engine with CRMs, ESPs, and
                        automation
                        tools. You can integrate using APIs, Zapier, or native connections. Once linked, your email
                        lists
                        are validated automatically, keeping your data accurate and your campaigns performing with 99%
                        accuracy.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="200ms">
                  <details>
                    <summary>Which platforms can I connect with KudosHub?</summary>
                    <div class="faq-content">
                      <p>KudosHub integrates with popular CRMs, ESPs, and automation tools, including HubSpot, Hubspot,
                        Apollo,
                        Mailchimp, and Zapier. You can also connect with custom platforms through our REST API or
                        webhook
                        integrations to automate validation directly inside your existing workflow.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="300ms">
                  <details>
                    <summary>How do I integrate KudosHub with my CRM or ESP?</summary>
                    <div class="faq-content">
                      <p>You can integrate KudosHub with your CRM or ESP using built-in connectors, Zapier, or custom
                        API
                        calls. Once connected, KudosHub automatically validates new and existing contacts, ensuring only
                        verified and deliverable email addresses enter your system.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="400ms">
                  <details>
                    <summary>Can KudosHub integrate with no-code tools like Zapier for automation?</summary>
                    <div class="faq-content">
                      <p>Yes. KudosHub integrates seamlessly with Zapier, allowing you to automate email validation and
                        scoring across more than 2,000 apps. No coding is required. Simply create a Zap, connect your
                        accounts, and start syncing clean, validated data in real time.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="500ms">
                  <details>
                    <summary>How long does it take to set up a KudosHub integration?</summary>
                    <div class="faq-content">
                      <p>Most KudosHub integrations can be set up in just a few minutes. With ready-to-use connectors,
                        Zapier templates, and a simple API structure, you can start validating emails, syncing contacts,
                        and
                        automating workflows almost instantly without technical expertise.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="600ms">
                  <details>
                    <summary>What types of integrations does KudosHub support (e.g., real-time vs. bulk)?</summary>
                    <div class="faq-content">
                      <p>KudosHub supports both real-time and bulk integrations. Real-time validation checks email
                        addresses
                        instantly during signups or form submissions, while bulk integrations let you upload large lists
                        for
                        batch processing. Both methods ensure high accuracy and prevent invalid data from entering your
                        system.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="700ms">
                  <details>
                    <summary>How does KudosHub’s API ensure real-time email verification during form submissions?
                    </summary>
                    <div class="faq-content">
                      <p>KudosHub’s API uses advanced syntax, domain, and mailbox-level checks to verify email addresses
                        instantly during form submissions. It flags invalid, disposable, or risky emails in real time,
                        ensuring only verified contacts are stored and maintaining high deliverability rates.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="800ms">
                  <details>
                    <summary>How do I handle errors and troubleshooting in KudosHub API calls?</summary>
                    <div class="faq-content">
                      <p>KudosHub provides detailed API responses and status codes to help identify issues quickly. You
                        can
                        monitor request logs, use sandbox mode for testing, and access developer documentation for
                        troubleshooting guides and sample code. Our support team is also available for live technical
                        assistance.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="900ms">
                  <details>
                    <summary>Is there a limit to how many tools I can integrate with KudosHub?</summary>
                    <div class="faq-content">
                      <p>No, there is no limit. You can integrate KudosHub with as many tools, CRMs, or platforms as
                        your
                        workflow requires. Our API and Zapier connections are designed to scale, making it easy to
                        manage
                        multiple integrations without affecting performance or accuracy.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="1000ms">
                  <details>
                    <summary>How can API integration help reduce email bounce rates and improve deliverability?
                    </summary>
                    <div class="faq-content">
                      <p>By validating every address through the KudosHub API before sending, you eliminate invalid or
                        temporary emails that cause bounces. This maintains sender reputation, improves inbox placement,
                        and
                        ensures your campaigns reach real, active recipients to increase overall deliverability and
                        engagement.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="1100ms">
                  <details>
                    <summary>How secure are KudosHub integrations when handling user data?</summary>
                    <div class="faq-content">
                      <p>KudosHub protects all integrations with enterprise-grade encryption, GDPR compliance, and
                        secure
                        data transfer protocols. API requests use HTTPS and token-based authentication to ensure that
                        your
                        data remains private, protected, and accessible only to authorized systems or users.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="1200ms">
                  <details>
                    <summary>Can KudosHub build custom integrations for my specific platform?</summary>
                    <div class="faq-content">
                      <p>Yes. Our development team can help you build or adapt custom integrations tailored to your
                        platform. Whether it is a private CRM, ESP, or proprietary system, KudosHub’s API and webhook
                        framework make it easy to create secure, scalable, and automated validation workflows.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="1300ms">
                  <details>
                    <summary>Is there a free tier or trial for testing KudosHub API integrations?</summary>
                    <div class="faq-content">
                      <p>Yes. KudosHub offers 3,000 free credits to test API integrations and evaluate performance. You
                        can
                        start validating emails, checking real-time responses, and automating workflows without any
                        setup
                        costs or long-term commitments.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="1400ms">
                  <details>
                    <summary>How can I integrate KudosHub’s AI Email Scoring into my existing tools or workflows?
                    </summary>
                    <div class="faq-content">
                      <p>You can integrate KudosHub’s AI Email Scoring through our API or Zapier to analyze engagement
                        likelihood, quality, and risk levels. The scoring system works alongside validation, providing
                        actionable insights that help you prioritize high-value leads and improve campaign ROI
                        automatically.</p>
                    </div>
                  </details>
                </div>
                <p class="wow animate__fadeInUp" data-wow-delay="1100ms"
                  style="font-size: 12px; padding-bottom:0px;margin-top: 30px !important">
                  * 3,000 free validations are distributed as 100 credits per day for 30 days. Unused daily
                  credits expire at the end of each day and do not roll over.
                </p>
                <p class="wow animate__fadeInUp docs-link" data-wow-delay="1300ms"
                  style="font-size: 12px; padding-top:0px;">
                  please refer our
                  <a href="./docs/email-validation" target="-blank">docs</a>
                  for more details
              </div>
            </div>
          </div>
          <!-- faq end -->
        </div>
      </div>
      <app-get-started-today></app-get-started-today>
      <!-- FOOTER START -->
      <div id="appFooter">
        <app-footer></app-footer>
      </div>
      <!-- FOOTER END -->
    </section>
    <section class="body-right-insidepages animate__animated animate__fadeInRight"> <a routerLink="/">
        <div class="pic-area">
          <div class="pic-zoom box02"></div>
          <div class="page-head">
            <div class="cross"><img src="theme/images/cross.svg" width="25" alt="cross"></div>
            <h2>INTEGRATION <img src="theme/images/side-img-icon.webp" width="40" alt="Who we are KudosHub"
                class="icon-pad"></h2>
          </div>
        </div>
      </a>
    </section>
  </div>
  }
</main>
}